import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { IUserInfo } from "../store/actions";

const RequireAuth = ({ allowedRoles = [] }: any) => {
  const authInfo: IUserInfo = useSelector(
    (state: any) => state.userAuthInfoState
  );
  const location = useLocation();

  const allAllowedRoles = [
    "user.admin",
    "production-manager",
    "production-scheduler",
    "chassis_prep",
    "wall_assembly_prep",
    "roof_assembly_prep",
    "doors_and_drawers_prep",
    "furniture_prep",
    "cnc_prep",
    "cnc_doors_drawers_prep",
    "electrical-qc",
    "plumber",
    "store",
    "chassis-elec-qa",
    "quality-assurance",
    "operation-manager",
    "compliance",
    "builder-qc",
    "line-manager-qc",
    "electrical-qc",
    "standard-inspection",
    "qa-manager-qc",
    "floor_and_lino_assembly",
    "production-review",
    "planning-manager",
  ];

  const hasAccess = allAllowedRoles.some((role: string) =>
    authInfo?.roles?.includes(role)
  );

  if (!authInfo || !authInfo.accessToken) {
    console.log("User not logged in, redirecting to login...");
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (!hasAccess) {
    console.log("User not authorized, redirecting to unauthorized...");
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};

export default RequireAuth;
